import React from "react";
import classNames from "../transfer.module.css";

const Footer = ({ children, className='transfer-student-footer' }, updatedStyle) => {
  return (
    <div className={classNames[className]} style={updatedStyle}>
      <div className="d-flex justify-content-between w-100 ml-3 mr-5">{children}</div>
    </div>
  );
};

export default Footer;
